import { Container } from '@cgs/wge';
import { IStorageMarshalService } from './storage-marshal.service';
import { IStorageService, STORAGE_SERVICE_TOKEN } from '../storage.service';

export class StorageMarshalBaseService implements IStorageMarshalService {
  private readonly storage: IStorageService;

  constructor(container: Container) {
    this.storage = container.resolve<IStorageService>(STORAGE_SERVICE_TOKEN);
  }

  public set item(item: { key: string; value?: string; json?: object; boolean?: boolean }) {
    if (item.value) {
      this.storage.setItem(item.key, item.value);
      return;
    }

    if (item.boolean !== undefined) {
      this.storage.setItem(item.key, item.boolean.toString());
      return;
    }

    if (item.json) {
      this.storage.setItem(item.key, JSON.stringify(item.json));
      return;
    }
  }

  public get item(): {
    value: <G = string>(key: string) => G | null;
    number: (key: string) => number | null;
    boolean: (key: string) => boolean;
    json: <T extends object>(key: string) => T;
  } {
    return {
      value: <G>(key: string) =>
        this.storage.getItem(key) ? (this.storage.getItem(key) as G) : null,
      boolean: (key: string) =>
        this.storage.getItem(key) ? this.storage.getItem(key) === 'true' : false,
      number: (key: string) =>
        this.storage.getItem(key) ? parseFloat(this.storage.getItem(key)!) : null,
      json: (key: string) =>
        this.storage.getItem(key) ? JSON.parse(this.storage.getItem(key) || '{}') : null,
    };
  }

  public hasKey(key: string): boolean {
    return this.storage.hasItem(key);
  }
}
